/**
 * useInviteModal hook
 * Wraps FriendsPageContext with computed values for the invite modal
 */

import { useMemo } from 'react';
import { useFriendsPage } from '../contexts/FriendsPageContext';
import { filterManualEmails } from '../helpers/inviteModal.helper';
import type { UseInviteModalReturn } from '../types/inviteModal.types';

export function useInviteModal(): UseInviteModalReturn {
  const {
    showInviteModal,
    handleCloseModal,
    inviteTab,
    setInviteTab,
    selectedContacts,
    toggleContactSelection,
    inviteMessage,
    setInviteMessage,
    searchQuery,
    setSearchQuery,
    manualEmail,
    setManualEmail,
    manualEmails,
    addManualEmail,
    removeManualEmail,
    handleSendInvitations,
    sendingInvites,
  } = useFriendsPage();

  const filteredManualEmails = useMemo(
    () => filterManualEmails(manualEmails, searchQuery),
    [manualEmails, searchQuery]
  );

  return {
    showInviteModal,
    handleCloseModal,
    inviteTab,
    setInviteTab,
    selectedContacts,
    toggleContactSelection,
    inviteMessage,
    setInviteMessage,
    searchQuery,
    setSearchQuery,
    manualEmail,
    setManualEmail,
    manualEmails,
    addManualEmail,
    removeManualEmail,
    handleSendInvitations,
    sendingInvites,
    filteredManualEmails,
  };
}
